// Canonical, externally-hosted legal documents. Linked from the Control Center
// and the onboarding compliance step. Keep these in one place so a URL change
// only has to happen once.
export const LEGAL_LINKS = {
  privacyPolicy: "https://www.hiive.club/privacy-policy",
  termsAndConditions: "https://www.hiive.club/terms-and-conditions",
  childSafetyStandards: "https://www.hiive.club/child-safety-standards",
  /**
   * End User License Agreement. App Store guideline 1.2 requires an app with
   * user-generated content to make members agree to an EULA *before* they
   * register or sign in, and requires that agreement to state that objectionable
   * content and abusive users are not tolerated. Rendered by
   * `components/auth/auth-legal-consent.tsx` on every sign-in surface.
   */
  eula: "https://www.hiive.club/eula",
} as const;
